'use client';

import React from 'react';
import { DefaultDropdown } from '@/components/ui/DefaultDropdown';
import { RegFormField } from '@/features/b2b/register/components/RegFormField';
import { HEAR_ABOUT_OPTIONS } from '@/features/b2b/register/services/registrationService';

export const HearAboutUsSection = ({ formData, handleSelectChange, handleInputChange, errors }) => {
  return (
    <>
      <p className="text-[#373945] text-base font-medium mb-2">
        How did you hear about us?
      </p>

      <div className={`mb-${formData.hear === 'Other' ? '6' : '12'}`}>
        <div className="mb-6">
          <DefaultDropdown
            items={HEAR_ABOUT_OPTIONS}
            onItemSelect={(value) => {
              handleSelectChange('hear')(value);
              if (value !== 'Other' && formData.hearOther !== '') {
                handleSelectChange('hearOther')('');
              }
            }}
            title={formData.hear || 'Select option'}
            maxHeight="max-h-96"
            errorClass={errors.hear ? 'border-2 border-[#D32F2F]' : ''}
          />
        </div>
      </div>

      {formData.hear === 'Other' && (
        <RegFormField
          label='If "Other" Enter Here'
          name="hearOther"
          value={formData.hearOther}
          onChange={handleInputChange}
          required={formData.hear === 'Other'}
          className="mb-12"
        />
      )}
    </>
  );
};
